import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import FloatingShapes from "@/components/FloatingShapes";
import Nav from "@/components/Nav";
import AuthSeoContent from "@/components/AuthSeoContent";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleLogin = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Password needs 6+ characters"); return; }
    setBusy(true);
    try { await register(form.email, form.password, form.name); nav("/dashboard"); toast.success("Deck opened."); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not register"); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen grain" data-testid="register-page">
      <FloatingShapes /><Nav />
      <main className="relative z-10 max-w-md mx-auto px-6 pt-32 pb-20">
        <h1 className="font-display text-5xl text-center">Start your stack</h1>
        <p className="font-hand text-stone-500 text-2xl text-center mt-2">first deck takes a minute</p>
        <form onSubmit={onSubmit} className="sticky-card p-8 mt-10 space-y-4" data-testid="register-form">
          <div>
            <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Name</label>
            <input value={form.name} onChange={e=>setForm({...form, name:e.target.value})}
                   className="input mt-2" placeholder="What should we call you?" data-testid="register-name-input"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Email</label>
            <input type="email" required value={form.email} onChange={e=>setForm({...form, email:e.target.value})}
                   className="input mt-2" data-testid="register-email-input"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Password</label>
            <input type="password" required minLength={6} value={form.password} onChange={e=>setForm({...form, password:e.target.value})}
                   className="input mt-2" data-testid="register-password-input"/>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full mt-2" data-testid="register-submit-button">
            {busy ? "Making space…" : "Create my deck"}
          </button>
        </form>
        <div className="flex items-center gap-3 my-6">
          <div className="h-px bg-stone-300 flex-1"/>
          <span className="text-xs uppercase tracking-[0.2em] text-stone-500">or</span>
          <div className="h-px bg-stone-300 flex-1"/>
        </div>
        <button onClick={googleLogin} className="btn-ghost w-full flex items-center justify-center gap-3" data-testid="google-register-button">
          Continue with Google
        </button>
        <p className="text-center text-stone-600 mt-8">
          Already a Loomer? <Link to="/login" className="text-indigo-600 hover:underline" data-testid="register-to-login-link">Sign in</Link>
        </p>
        <AuthSeoContent variant="register" />
      </main>
    </div>
  );
}
